import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=70b3ee1e&scoped=true"
import script from "./registry.vue?vue&type=script&lang=js"
export * from "./registry.vue?vue&type=script&lang=js"
import style0 from "./registry.vue?vue&type=style&index=0&id=70b3ee1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3ee1e",
  null
  
)

export default component.exports